import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#remove_from_cart
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackRemoveFromCartItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackRemoveFromCartParameters
    extends TrackEventListParameters<"currency" | "value", null, TrackRemoveFromCartItem> {}

const trackRemoveFromCart = (parameters: TrackRemoveFromCartParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "remove_from_cart", ...parameters }, { ...options, skipItemIndex: true });
};

export default trackRemoveFromCart;
